import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { NgForm } from '@angular/forms';
import { Roulette } from 'app/public/model/roulette.model';
import { WebRouletteService } from 'app/public/services/web-roulette.service';

@Component({
  selector: 'app-roulette-coupons-settings',
  templateUrl: './roulette-coupons-settings.component.html',
  styleUrls: ['./roulette-coupons-settings.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class RouletteCouponsSettingsComponent implements OnInit {

  @Input()
  roulette: Roulette;
  @Input() form: NgForm

  icons: { Id: number, Url: string }[];

  constructor(private webRouletteService: WebRouletteService) { }

  get coupons() {
    return this.roulette?.Coupons;
  }

  ngOnInit(): void {
    this.webRouletteService.getCouponsIcons().subscribe(icns => this.icons = icns);
  }

}
